<template>
  <div id="Staffonly">
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSeGh74WXVxTqpJht4V39aZGVn8MnCuraNmfjhFz4DMYuvssBg/viewform?embedded=true"
      width="100%"
      height="100%"
      min-height="100%"
    >載入中…</iframe>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="sass" scoped>
#Staffonly
  height: calc( 100vh - 214px )
</style>
